
import React from 'react';
import { Link } from 'react-router-dom';
import FeedbackButton from './FeedbackButton';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 py-8 pt-12 font-poppins-regular">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-poppins-bold text-lg mb-4">MediHub</h3>
            <p className="text-gray-600 text-sm">
              Az első online egészségügyi rendezvénynaptár, amely segít elkerülni az időpontütközéseket
              és átláthatóvá teszi a szakmai eseményeket.
            </p>
            <div className="mt-4">
              <FeedbackButton />
            </div>
          </div>

          <div>
            <h3 className="font-poppins-bold text-lg mb-4">Linkek</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-gray-900 text-sm">
                  Főoldal
                </Link>
              </li>
              <li>
                <Link to="/calendar" className="text-gray-600 hover:text-gray-900 text-sm">
                  Naptár
                </Link>
              </li>
              <li>
                <Link to="/why-medihub" className="text-gray-600 hover:text-gray-900 text-sm">
                  Miért a MediHub?
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-poppins-bold text-lg mb-4">Jogi információk</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal/terms" className="text-gray-600 hover:text-gray-900 text-sm">
                  Felhasználási feltételek
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" className="text-gray-600 hover:text-gray-900 text-sm">
                  Adatvédelmi irányelvek
                </Link>
              </li>
              <li>
                <Link to="/legal/cookie-policy" className="text-gray-600 hover:text-gray-900 text-sm">
                  Cookie szabályzat
                </Link>
              </li>
              <li>
                <Link to="/legal/imprint" className="text-gray-600 hover:text-gray-900 text-sm">
                  Impresszum
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-6">
          <div className="text-sm text-gray-600 flex flex-col md:flex-row justify-between">
            <p>© {currentYear} MediHub. Minden jog fenntartva.</p>
            <p className="mt-2 md:mt-0">Üzemeltető: Ementin Kft. | Adószám: 14806603-2-42</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
